/**
 * @flow
 * @relayHash d93fdd2ef93e2a5263b877f2be19a7b4
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type BaseTitleCard_viewer$ref = any;
type TitlePaginator_query$ref = any;
export type CustomerNotificationSubscriptionType = "BESTSELLER" | "STEADYSELLER" | "SUDDEN_RISE" | "%future added value";
export type Order = "ASC" | "DEFAULT" | "DESC" | "%future added value";
export type PublishedFilter = "ANY" | "FUTURE" | "LAST_12_MONTHS" | "LAST_4_MONTHS" | "NEXT_14_DAYS" | "TODAY" | "%future added value";
export type SearchMode = "PUBLISHING_HOUSE" | "STORE" | "%future added value";
export type TitleOrderBy = "AUTHOR" | "CATEGORY" | "DEFAULT" | "META_SCORE" | "NEWS_COUNT" | "POPULARITY_SCORE" | "PUBLICATION_COUNT" | "PUBLISHED_FIRST" | "PUBLISHED_LATEST" | "REVIEW_COUNT" | "SEARCH_CATEGORY" | "TIMESTAMP_CREATED" | "TITLE" | "%future added value";
export type TitlesResultsPageQueryVariables = {|
  orderBy?: ?TitleOrderBy,
  order?: ?Order,
  search?: ?string,
  excludeDigital?: ?boolean,
  excludeUnavailable?: ?boolean,
  filterBy?: ?$ReadOnlyArray<string>,
  published?: ?PublishedFilter,
  mode: SearchMode,
  onlyFavorites: boolean,
  onlyWithNotificationTypes?: ?$ReadOnlyArray<CustomerNotificationSubscriptionType>,
|};
export type TitlesResultsPageQueryResponse = {|
  +viewer: {|
    +$fragmentRefs: BaseTitleCard_viewer$ref
  |},
  +$fragmentRefs: TitlePaginator_query$ref,
|};
export type TitlesResultsPageQuery = {|
  variables: TitlesResultsPageQueryVariables,
  response: TitlesResultsPageQueryResponse,
|};
*/


/*
query TitlesResultsPageQuery(
  $orderBy: TitleOrderBy
  $order: Order
  $search: String
  $excludeDigital: Boolean
  $excludeUnavailable: Boolean
  $filterBy: [ID!]
  $published: PublishedFilter
  $mode: SearchMode!
  $onlyFavorites: Boolean!
  $onlyWithNotificationTypes: [CustomerNotificationSubscriptionType!]
) {
  ...TitlePaginator_query_3riI3h
  viewer {
    ...BaseTitleCard_viewer
    id
  }
}

fragment BaseTitleCard_title on Title {
  id
  title
  publishingHouseDescription
  yearPublishedFirst
  datePublishedFirst
  yearPublishedLatest
  datePublishedLatest
  hasMoreAuthors
  popularityScore
  popularityScoreWeekAgo
  popularityScoreYesterday
  metaScore
  onlineMetaScore
  newspaperMetaScore
  reviewCount
  onlineReviewCount
  newspaperReviewCount
  category {
    id
    name
  }
  searchCategory {
    id
    name
  }
  authors {
    id
    name
  }
  publishingHouses {
    id
    name
  }
  coverImage {
    sizes {
      name
      url
    }
    id
  }
  publications {
    id
    availability
    isDigital
    publishingHouse {
      id
    }
    ...PublicationCard_publication
  }
  collections {
    id
    description
    name
    type
    isVerified
    titles {
      id
      title
      yearPublishedFirst
    }
  }
}

fragment BaseTitleCard_viewer on Customer {
  favoriteIds
  ...FavoriteStar_viewer
  ...PublicationCard_viewer
}

fragment FavoriteStar_viewer on Customer {
  favoriteIds
}

fragment MessageCard_message on Message {
  id
  activeFrom
  body
  canEdit
  includeLinkToBogportalen
  isActive
  status
  subject
  timestampCreated
  sender {
    id
    name
    type
    isAdministrator
    group {
      name
      type
      parentGroups {
        name
        id
      }
      id
    }
  }
  links {
    url
    description
  }
  attachments {
    description
    file {
      url
      id
    }
  }
  referencedPublications {
    isbn13
    id
  }
  aggregateReferencedTitles {
    title
    id
  }
  referencedEntities {
    name
    id
  }
  referencedPublishingHouses {
    name
    id
  }
}

fragment MessageCard_viewer on Customer {
  id
}

fragment NotificationCard_title on Title {
  id
  title
  hasMoreAuthors
  authors {
    id
    name
  }
}

fragment PopularityTitleCard_title on Title {
  datePublishedFirst
  hasMoreAuthors
  title
  authors {
    id
    name
  }
  popularityScore120DayHistory {
    date
    score
  }
  ...BaseTitleCard_title
}

fragment PopularityTitleCard_viewer on Customer {
  ...BaseTitleCard_viewer
}

fragment PublicationCard_publication on Publication {
  id
  title
  subtitle
  format
  pageCount
  isbn13
  datePublished
  yearPublished
  priceRetail
  availability
  isDigital
  hasMoreTranslators
  hasMoreAuthors
  authors {
    id
    name
  }
  translators {
    id
    name
  }
  publishingHouse {
    id
    name
  }
  coverImage {
    sizes {
      name
      url
    }
    id
  }
}

fragment PublicationCard_viewer on Customer {
  ...FavoriteStar_viewer
}

fragment TitlePaginator_query_3riI3h on Query {
  titles(first: 10, orderBy: $orderBy, order: $order, search: $search, excludeDigital: $excludeDigital, excludeUnavailable: $excludeUnavailable, filterBy: $filterBy, published: $published, mode: $mode, onlyFavorites: $onlyFavorites, onlyWithNotificationTypes: $onlyWithNotificationTypes) {
    totalCount
    edges {
      node {
        id
        activeNotifications
        relatedMessages {
          id
          isActive
          isDeleted
          ...MessageCard_message
        }
        ...BaseTitleCard_title
        ...PopularityTitleCard_title
        ...NotificationCard_title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  viewer {
    ...BaseTitleCard_viewer
    ...PopularityTitleCard_viewer
    ...MessageCard_viewer
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "orderBy",
    "type": "TitleOrderBy",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "order",
    "type": "Order",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "excludeDigital",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "excludeUnavailable",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "filterBy",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "published",
    "type": "PublishedFilter",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "mode",
    "type": "SearchMode!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "onlyFavorites",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "onlyWithNotificationTypes",
    "type": "[CustomerNotificationSubscriptionType!]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "excludeDigital",
  "variableName": "excludeDigital"
},
v2 = {
  "kind": "Variable",
  "name": "excludeUnavailable",
  "variableName": "excludeUnavailable"
},
v3 = {
  "kind": "Variable",
  "name": "filterBy",
  "variableName": "filterBy"
},
v4 = {
  "kind": "Variable",
  "name": "mode",
  "variableName": "mode"
},
v5 = {
  "kind": "Variable",
  "name": "onlyFavorites",
  "variableName": "onlyFavorites"
},
v6 = {
  "kind": "Variable",
  "name": "onlyWithNotificationTypes",
  "variableName": "onlyWithNotificationTypes"
},
v7 = {
  "kind": "Variable",
  "name": "order",
  "variableName": "order"
},
v8 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v9 = {
  "kind": "Variable",
  "name": "published",
  "variableName": "published"
},
v10 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v11 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/)
],
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v15 = [
  (v13/*: any*/),
  (v12/*: any*/)
],
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isbn13",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "yearPublishedFirst",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasMoreAuthors",
  "args": null,
  "storageKey": null
},
v22 = [
  (v12/*: any*/),
  (v13/*: any*/)
],
v23 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "authors",
  "storageKey": null,
  "args": null,
  "concreteType": "Entity",
  "plural": true,
  "selections": (v22/*: any*/)
},
v24 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "coverImage",
  "storageKey": null,
  "args": null,
  "concreteType": "PublicationCoverImage",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sizes",
      "storageKey": null,
      "args": null,
      "concreteType": "PublicationCoverImageSize",
      "plural": true,
      "selections": [
        (v13/*: any*/),
        (v16/*: any*/)
      ]
    },
    (v12/*: any*/)
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "TitlesResultsPageQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Customer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "BaseTitleCard_viewer",
            "args": null
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "TitlePaginator_query",
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "TitlesResultsPageQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "titles",
        "storageKey": null,
        "args": (v11/*: any*/),
        "concreteType": "TitleConnection",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "TitleEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Title",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "activeNotifications",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "relatedMessages",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Message",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isActive",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isDeleted",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "activeFrom",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "body",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "canEdit",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "includeLinkToBogportalen",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "status",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "subject",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "timestampCreated",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "sender",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Customer",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isAdministrator",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "group",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CustomerGroup",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              (v14/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "parentGroups",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "CustomerGroup",
                                "plural": true,
                                "selections": (v15/*: any*/)
                              },
                              (v12/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "links",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MessageLink",
                        "plural": true,
                        "selections": [
                          (v16/*: any*/),
                          (v17/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "attachments",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MessageAttachhment",
                        "plural": true,
                        "selections": [
                          (v17/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "file",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "File",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              (v12/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "referencedPublications",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Publication",
                        "plural": true,
                        "selections": [
                          (v18/*: any*/),
                          (v12/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "aggregateReferencedTitles",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Title",
                        "plural": true,
                        "selections": [
                          (v19/*: any*/),
                          (v12/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "referencedEntities",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Entity",
                        "plural": true,
                        "selections": (v15/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "referencedPublishingHouses",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PublishingHouse",
                        "plural": true,
                        "selections": (v15/*: any*/)
                      }
                    ]
                  },
                  (v19/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "publishingHouseDescription",
                    "args": null,
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "datePublishedFirst",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "yearPublishedLatest",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "datePublishedLatest",
                    "args": null,
                    "storageKey": null
                  },
                  (v21/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "popularityScore",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "popularityScoreWeekAgo",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "popularityScoreYesterday",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "metaScore",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "onlineMetaScore",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "newspaperMetaScore",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "reviewCount",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "onlineReviewCount",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "newspaperReviewCount",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "category",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Category",
                    "plural": false,
                    "selections": (v22/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "searchCategory",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchCategory",
                    "plural": false,
                    "selections": (v22/*: any*/)
                  },
                  (v23/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "publishingHouses",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PublishingHouse",
                    "plural": true,
                    "selections": (v22/*: any*/)
                  },
                  (v24/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "publications",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Publication",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "availability",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isDigital",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "publishingHouse",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PublishingHouse",
                        "plural": false,
                        "selections": (v22/*: any*/)
                      },
                      (v19/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "subtitle",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "format",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "pageCount",
                        "args": null,
                        "storageKey": null
                      },
                      (v18/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "datePublished",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "yearPublished",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "priceRetail",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasMoreTranslators",
                        "args": null,
                        "storageKey": null
                      },
                      (v21/*: any*/),
                      (v23/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "translators",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Entity",
                        "plural": true,
                        "selections": (v22/*: any*/)
                      },
                      (v24/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "collections",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Collection",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      (v17/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isVerified",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "titles",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Title",
                        "plural": true,
                        "selections": [
                          (v12/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "popularityScore120DayHistory",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "HistoricalDailyPopularityScore",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "date",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "score",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "titles",
        "args": (v11/*: any*/),
        "handle": "connection",
        "key": "TitlePaginator_titles",
        "filters": [
          "orderBy",
          "order",
          "search",
          "excludeDigital",
          "excludeUnavailable",
          "filterBy",
          "published",
          "mode",
          "onlyFavorites",
          "onlyWithNotificationTypes"
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Customer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "favoriteIds",
            "args": null,
            "storageKey": null
          },
          (v12/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "TitlesResultsPageQuery",
    "id": null,
    "text": "query TitlesResultsPageQuery(\n  $orderBy: TitleOrderBy\n  $order: Order\n  $search: String\n  $excludeDigital: Boolean\n  $excludeUnavailable: Boolean\n  $filterBy: [ID!]\n  $published: PublishedFilter\n  $mode: SearchMode!\n  $onlyFavorites: Boolean!\n  $onlyWithNotificationTypes: [CustomerNotificationSubscriptionType!]\n) {\n  ...TitlePaginator_query_3riI3h\n  viewer {\n    ...BaseTitleCard_viewer\n    id\n  }\n}\n\nfragment BaseTitleCard_title on Title {\n  id\n  title\n  publishingHouseDescription\n  yearPublishedFirst\n  datePublishedFirst\n  yearPublishedLatest\n  datePublishedLatest\n  hasMoreAuthors\n  popularityScore\n  popularityScoreWeekAgo\n  popularityScoreYesterday\n  metaScore\n  onlineMetaScore\n  newspaperMetaScore\n  reviewCount\n  onlineReviewCount\n  newspaperReviewCount\n  category {\n    id\n    name\n  }\n  searchCategory {\n    id\n    name\n  }\n  authors {\n    id\n    name\n  }\n  publishingHouses {\n    id\n    name\n  }\n  coverImage {\n    sizes {\n      name\n      url\n    }\n    id\n  }\n  publications {\n    id\n    availability\n    isDigital\n    publishingHouse {\n      id\n    }\n    ...PublicationCard_publication\n  }\n  collections {\n    id\n    description\n    name\n    type\n    isVerified\n    titles {\n      id\n      title\n      yearPublishedFirst\n    }\n  }\n}\n\nfragment BaseTitleCard_viewer on Customer {\n  favoriteIds\n  ...FavoriteStar_viewer\n  ...PublicationCard_viewer\n}\n\nfragment FavoriteStar_viewer on Customer {\n  favoriteIds\n}\n\nfragment MessageCard_message on Message {\n  id\n  activeFrom\n  body\n  canEdit\n  includeLinkToBogportalen\n  isActive\n  status\n  subject\n  timestampCreated\n  sender {\n    id\n    name\n    type\n    isAdministrator\n    group {\n      name\n      type\n      parentGroups {\n        name\n        id\n      }\n      id\n    }\n  }\n  links {\n    url\n    description\n  }\n  attachments {\n    description\n    file {\n      url\n      id\n    }\n  }\n  referencedPublications {\n    isbn13\n    id\n  }\n  aggregateReferencedTitles {\n    title\n    id\n  }\n  referencedEntities {\n    name\n    id\n  }\n  referencedPublishingHouses {\n    name\n    id\n  }\n}\n\nfragment MessageCard_viewer on Customer {\n  id\n}\n\nfragment NotificationCard_title on Title {\n  id\n  title\n  hasMoreAuthors\n  authors {\n    id\n    name\n  }\n}\n\nfragment PopularityTitleCard_title on Title {\n  datePublishedFirst\n  hasMoreAuthors\n  title\n  authors {\n    id\n    name\n  }\n  popularityScore120DayHistory {\n    date\n    score\n  }\n  ...BaseTitleCard_title\n}\n\nfragment PopularityTitleCard_viewer on Customer {\n  ...BaseTitleCard_viewer\n}\n\nfragment PublicationCard_publication on Publication {\n  id\n  title\n  subtitle\n  format\n  pageCount\n  isbn13\n  datePublished\n  yearPublished\n  priceRetail\n  availability\n  isDigital\n  hasMoreTranslators\n  hasMoreAuthors\n  authors {\n    id\n    name\n  }\n  translators {\n    id\n    name\n  }\n  publishingHouse {\n    id\n    name\n  }\n  coverImage {\n    sizes {\n      name\n      url\n    }\n    id\n  }\n}\n\nfragment PublicationCard_viewer on Customer {\n  ...FavoriteStar_viewer\n}\n\nfragment TitlePaginator_query_3riI3h on Query {\n  titles(first: 10, orderBy: $orderBy, order: $order, search: $search, excludeDigital: $excludeDigital, excludeUnavailable: $excludeUnavailable, filterBy: $filterBy, published: $published, mode: $mode, onlyFavorites: $onlyFavorites, onlyWithNotificationTypes: $onlyWithNotificationTypes) {\n    totalCount\n    edges {\n      node {\n        id\n        activeNotifications\n        relatedMessages {\n          id\n          isActive\n          isDeleted\n          ...MessageCard_message\n        }\n        ...BaseTitleCard_title\n        ...PopularityTitleCard_title\n        ...NotificationCard_title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  viewer {\n    ...BaseTitleCard_viewer\n    ...PopularityTitleCard_viewer\n    ...MessageCard_viewer\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f898a260d03a64837228bc7d93db0e83';
module.exports = node;
